export default function NoteReviewOutput({ emptyMessage, icon, items, testId, title }) {
  if (!items) return null;

  return (
    <div className="note-review-output" data-testid={testId}>
      <h3>
        {icon}
        {title}
      </h3>
      {items.length === 0 ? (
        <p data-testid={`${testId}-empty`}>{emptyMessage}</p>
      ) : (
        items.map((item, index) => (
          <article
            className="note-review-item"
            data-testid={`${testId}-item-${index}`}
            key={`${item.stage}-${item.side}-${index}`}
          >
            <span data-testid={`${testId}-item-label-${index}`}>
              {item.stage} · {item.side}
            </span>
            <p data-testid={`${testId}-item-text-${index}`}>{item.text}</p>
          </article>
        ))
      )}
    </div>
  );
}